import styled from 'styled-components';

export const Wrapper = styled.div`
  // PRIMARY BUTTON
  .primaryBtn {
    display: flex;
    align-items: center;
    padding: 10px 16px;
    border-radius: 8px;
    border: 1px solid #008cff;
    color: #008cff;
    font-size: 14px;
    line-height: 20px;
    font-weight: 900;
    text-transform: uppercase;
    margin-left: auto;
    background: none;
  }

  // LINK BUTTON
  button.linkBtn {
    cursor: pointer;
    outline: none;
    background-color: white;
    padding: 4px 8px;
    font-size: 12px;
    line-height: 16px;
    border-radius: 4px;
    font-weight: 900;
    color: Theme.$primaryColor;
    border: 1px Theme.$primaryColor solid;
    font-family: Theme.$globalFontFamily;
  }

  button.linkBtn.disabledBtn {
    cursor: not-allowed !important;
    color: Theme.$tertiaryText !important;
    border: 1px Theme.$tertiaryText solid !important;
  }

  button.linkBtn.disabledBtn.withShadow {
    box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.21);
  }

  button.linkBtn.smallActnBtn {
    padding: 7px 16px;
    font-size: 14px;
    line-height: 20px;
    font-weight: 900;
    color: Theme.$primaryColor;
    border: 1px Theme.$primaryColor solid;
    background: white;
  }

  button.linkBtn.smallActnBtnBlue {
    padding: 7px 16px;
    font-size: 14px;
    line-height: 20px;
    font-weight: 900;
    color: Theme.$blueText;
    border: 1px Theme.$blueText solid;
    background: white;
  }

  button.linkBtn.regularActnBtn {
    padding: 10px 16px;
    font-size: 16px;
    line-height: 24px;
    font-weight: 900;
    color: Theme.$primaryColor;
    border: 1px Theme.$primaryColor solid;
    background: white;
  }

  button.linkBtn.addItemBtn {
    padding: 10px 16px;
    font-size: 16px;
    line-height: 24px;
  }

  button.linkBtn.viewOptnsBtn {
    padding: 7px 16px;
    font-size: 14px;
    line-height: 16px;
  }

  button.linkBtn.myAccBtn {
    padding: 10px 16px;
    font-size: 16px;
    line-height: 16px;
    color: white;
    border: 1px white solid;
    background-color: transparent;
  }

  button.lcActionBtn {
    cursor: pointer;
    outline: none;
    border: none;
    border-radius: 3px;
    background: #ffffff;
    color: Theme.$primaryColor;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.2);
  }

  button.lcActionBtn.disabledBtn {
    pointer-events: none;
    color: rgba(0, 0, 0, 0.3) !important;
    cursor: not-allowed !important;
  }

  button.lcActionBtn.lgBtn {
    padding: 10px 12px;
    font-size: 16px;
    font-weight: 900;
  }

  button.lcActionBtn.smallBtn {
    padding: 8px 32px;
    font-size: 12px;
    font-weight: 700;
  }

  button.width118 {
    min-width: 118px;
  }

  .primaryBtn.width200 {
    min-width: 200px;
  }

  .primaryBtn.width180 {
    min-width: 180px;
  }

  .primaryBtn.width250 {
    min-width: 250px;
  }
  .primaryBtn.width140 {
    min-width: 140px;
  }

  .primaryBtn.height50 {
    min-height: 50px;
  }

  .checkBoxBtn {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 6px 5px;
    background: #ffffff;
    border: 1px solid Theme.$blueText;
    box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.21);
    border-radius: 4px;
    cursor: pointer;
    font-weight: 900;
    font-size: 14px;
    line-height: 20px;
    color: Theme.$blueText;
    & .customCheckbox b {
      border-color: Theme.$blueText;
    }
  }

  .editableClick {
    align-items: center;
    padding: 10px 16px;
    border-radius: 8px;
    border: 1px solid #008cff;
    background: none;
    color: #008cff;
    font-size: 14px;
    line-height: 20px;
    font-weight: 900;
    text-transform: uppercase;
    margin-left: auto;
  }

  .secondaryBtn {
    padding: 10px 16px;
    font-size: 16px;
    line-height: 24px;
    font-weight: 900;
    color: Theme.$primaryColor;
    border: 1px Theme.$primaryColor solid;
    background: #ffffff;
    cursor: pointer;
    &.round {
      border-radius: 24px;
    }
    &.square {
      border-radius: 4px;
    }
    &.oval {
      border-radius: 8px;
    }
    &.disabledBtn {
      cursor: not-allowed;
      background: Theme.$tertiaryText !important;
    }
  }
`;
